import { Reveal } from "../common/Reveal";
import Cta from "../common/Cta";

export default function FinalCTA() {
  return (
    <section className="relative py-28 md:py-40 kv-radial overflow-hidden" data-testid="section-final-cta">
      <div className="absolute inset-0 kv-grid-bg opacity-20" aria-hidden />
      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-kv-off leading-[1.02] text-balance">
            Build the next version of your business.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 font-body text-base md:text-lg text-kv-grey leading-relaxed max-w-2xl mx-auto">
            Start with a strategy session. We will identify where better systems, automation, and intelligent agents can create the greatest operational and commercial impact.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap gap-4 justify-center">
            <Cta to="/contact" testId="final-strategy-call" arrow>Book a Strategy Call</Cta>
            <Cta to="/mythoros" variant="secondary" testId="final-explore-agent">Explore Mythoros©</Cta>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
